import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { getCostCodes, syncCostCodes, syncCustomers, syncFieldNotesFromQB, syncFieldNotesToQB, syncTeams, syncTimeclockFromQB, syncTimeclockToQB } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useDashboardRoles } from "@/pages/dashboard/useDashboardRoles";

export function useDataManagementViewModel() {
  const { user } = useAuth();
  const { isAdmin } = useDashboardRoles();
  const queryClient = useQueryClient();
  const { data: costCodesData } = useQuery({
    queryKey: ["cost-codes", ""],
    queryFn: () => getCostCodes(""),
    enabled: !!isAdmin,
  });
  const syncCostCodesMutation = useMutation({
    mutationFn: () => syncCostCodes(),
    onSuccess: async () => { await queryClient.invalidateQueries({ queryKey: ["cost-codes"] }); },
  });
  const syncCustomersMutation = useMutation({
    mutationFn: () => syncCustomers(),
    onSuccess: async () => { await queryClient.invalidateQueries({ queryKey: ["customers"] }); },
  });
  const syncTeamsMutation = useMutation({ mutationFn: () => syncTeams() });
  const syncTimeclockFromQBMutation = useMutation({
    mutationFn: () => syncTimeclockFromQB(),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["entries"] });
      await queryClient.invalidateQueries({ queryKey: ["recent-entries"] });
    },
  });
  const syncFieldNotesFromQBMutation = useMutation({
    mutationFn: () => syncFieldNotesFromQB(),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["field-notes"] });
      await queryClient.invalidateQueries({ queryKey: ["field-notes-count"] });
      await queryClient.invalidateQueries({ queryKey: ["field-notes-review"] });
      await queryClient.invalidateQueries({ queryKey: ["punch-notes-review"] });
      await queryClient.invalidateQueries({ queryKey: ["punch-notes-review-count"] });
    },
  });
  const syncFieldNotesToQBMutation = useMutation({
    mutationFn: () => syncFieldNotesToQB(),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["field-notes"] });
      await queryClient.invalidateQueries({ queryKey: ["field-notes-count"] });
      await queryClient.invalidateQueries({ queryKey: ["field-notes-review"] });
      await queryClient.invalidateQueries({ queryKey: ["punch-notes-review"] });
      await queryClient.invalidateQueries({ queryKey: ["punch-notes-review-count"] });
    },
  });
  const syncTimeclockToQBMutation = useMutation({
    mutationFn: () => syncTimeclockToQB(),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["entries"] });
      await queryClient.invalidateQueries({ queryKey: ["recent-entries"] });
    },
  });
  return {
    user,
    costCodesData,
    syncCostCodesMutation,
    syncCustomersMutation,
    syncTeamsMutation,
    syncTimeclockFromQBMutation,
    syncFieldNotesFromQBMutation,
    syncFieldNotesToQBMutation,
    syncTimeclockToQBMutation,
  };
}
